import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { regions, regionIdMaps } from '@/utils';
import { computed, watch } from 'vue';
export const useRegionArea = () => {
  const provinceList = [...regions];
  const area = reactive({
    provinceId: '',
    cityId: '',
    countyId: ''
  });
  const selectProvince = computed(() => {
    return regionIdMaps[area.provinceId] || null;
  });
  const cityList = computed(() => {
    const {
      children = []
    } = selectProvince.value || {};
    return children;
  });
  const selectCity = computed(() => {
    return (cityList.value || []).find(t => t.value === area.cityId) || null;
  });
  const countyList = computed(() => {
    const {
      children = []
    } = selectCity.value || {};
    return children;
  });
  const selectCounty = computed(() => {
    return (countyList.value || []).find(t => t.value === area.countyId) || null;
  });
  watch(() => area.provinceId, (newVal, oldVal) => {
    if (oldVal !== '' && newVal !== '') {
      area.cityId = '';
      area.countyId = '';
    }
  }, {
    immediate: true
  });
  watch(() => area.cityId, (newVal, oldVal) => {
    const tmpProvince = selectProvince.value;
    if (tmpProvince) {
      const idx = (tmpProvince.children || []).findIndex(t => t.value === newVal);
      if (idx === -1) {
        area.countyId = '';
      }
    }
  }, {
    immediate: true
  });
  return {
    area,
    provinceList,
    selectProvince,
    cityList,
    selectCity,
    countyList,
    selectCounty
  };
};